import { Component, OnInit } from '@angular/core';
import { Router , ActivatedRoute,} from '@angular/router';
import { ProductsService } from '../services/products.service';

@Component({
  selector: 'app-policies',
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.css']
})
export class PoliciesComponent implements OnInit {
  staticdata: any;
  flag: number;

  constructor(private route: ActivatedRoute, private productService: ProductsService) {
    window.scrollTo(0, 0);
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.flag = id;
       });
  }

  ngOnInit() {
    this.getStaticData();
  }

  getStaticData() {
    this.productService.getStaticData()
    .subscribe((x) => {
      this.staticdata = x;

    });

}

}
